import axiosClient from "axiosClient";
import { axiosHyperwolfClientBlaze } from "axiosClient";
import { axiosHyperwolfClient } from "axiosClient";
import axiosClientStilo from "axiosClient/indexStilo";
import { getQueryString } from "utilities/common";
import { STILO } from "utilities/constants";
const adminsMode = JSON.parse(localStorage.getItem('adminsMode'))

export async function fetchProductsAPI(filters, data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/product/list?${getQueryString(filters)}`, data);
}

export async function fetchProductDetailsAPI(productId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/product/${productId}?userType=admin`);
}

export async function addProductAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/product`, data);
}

export async function updateProductAPI(data, productId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/product/update/${productId}`, data);
}

export async function updateProductBatchAPI(data, batchId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`/api/v1/productBatch/${batchId}`, data);
}

export async function assignInventoryAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/product/inventory/assigned`, data);
}

export async function fetchProductBatchsAPI(filters, productId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/productBatch/${productId}?${getQueryString(filters)}`);
}

export async function fetchProductInventoriesAPI(filters, productId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/product/inventory/${productId}?${getQueryString(filters)}`);
}

export async function createProductBatchAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/productBatch`, data);
}

export async function deleteProductAPI(productId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`/api/v1/product/${productId}`);
}

export async function deleteProductBatchAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/productBatch/delete`, data);
}



export async function fetchProductTerpenoidAPI(filters, productId) {
    return await axiosClient.get(`/api/v1/product/terpenoids/details/${productId}?${getQueryString(filters)}`);
}


export async function productFiltersAPI(filters, data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post(`/api/v1/product/terpenoids/details/${productId}?${getQueryString(filters)}`, data);
}

export async function productActivityLogsAPI(filters) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/product/inventory/activity/logs?${getQueryString(filters)}`)
}


export async function fetchProductInstructionsAPI(categoryName) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/product/fetch/instructions?categoryName=${categoryName}`)
}

export async function fetchHoldQuantityAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`/api/v1/product/hold/quantity/status?productId=${data}`)
}



export async function createProductTraitAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post('api/v1/product/traits/assignment', data)
}

export async function updateProductTraitAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).put(`api/v1/product/traits/update`, data)
}


export async function fetchProductTraitsAPI(id, filters) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/product/traits/details/${id}?${getQueryString(filters)}`)
}

export async function deleteProductTraitAPI(productId, productTraitId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`api/v1/product/traits/delete/${productId}/${productTraitId}`)
}

export async function addProductStrainAPI(data) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).post('api/v1/product/traits/assign/multiple/strains', data)
}

export async function fetchProductStrainsAPI() {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get('api/v1/strain/selection/listing')
}

export async function deleteProductStrainAPI(productId, subStrainSlug) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).delete(`api/v1/product/delete/matched/strains?productId=${productId}&subStrainSlug=${subStrainSlug}`)
}

export async function getProductTraitDetailAPI(productId, traitId) {
    return await (adminsMode === STILO ? axiosClientStilo : axiosClient).get(`api/v1/product/traits/individual/details?productId=${productId}&traitId=${traitId}`)
}


export async function getSubTraitsForMainAPI(filters) {
    return await axiosClient.get(`/api/v1/product/traits/sub/listing?${getQueryString(filters)}`);
}

export async function getDeliverySlotsApi(filters) {
    return await axiosHyperwolfClientBlaze.get(`/api/v1/partner/store/cart/slots?${getQueryString(filters)}`);
}

export async function getProductCarouselsAPI(filters) {
    return await axiosHyperwolfClient.get(`/api/v1/product/carousel/listing?${getQueryString(filters)}`);
}